module.exports = __webpack_public_path__ + "static/img/shezhi_touzhu.28b653a2.png";